import { BaseModel } from "@blue-chip/core";
import CustomReport from "./CustomReport";

export default class CustomReportDataOption extends BaseModel {
  static get belongsTo() {
    return [CustomReport];
  }
}
